import { jsonToHtml } from '@contentstack/json-rte-serializer';
import WindowSize from '@/utils/windowSize';
import Image from 'next/image';
import { useModal, MODAL_TYPES } from './ModalProvider';

export default function RadioSelectorModalWrapper({
  isOpen,
  onClose,
  modalSettings
}) {
  const { modalUtils, getCloseButton } = useModal();
  const bodyCopy = modalSettings?.bodyCopy;
  const heading = modalSettings?.heading;
  const images = reshapeImageSettings(modalSettings?.images);

  const windowSize = WindowSize();
  const onMobile = windowSize.width < 640;

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.variantHelp,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <>
        <div className="py-2">
          {getCloseButton(MODAL_TYPES.variantHelp, onClose)}
        </div>

        {images && (
          <ModalImage image={onMobile ? images.mobile : images.desktop} />
        )}

        {heading && <div className="h4 mb-2">{heading}</div>}
        {bodyCopy && (
          <div
            className="rte body-r"
            dangerouslySetInnerHTML={{ __html: jsonToHtml(bodyCopy) }}
          />
        )}
      </>
    )
  });
}

const ModalImage = ({ image }) => {
  if (!image?.url) {
    return null;
  }

  if (!image?.dimension) {
    console.warn('Image dimensions are missing', image);
  }

  return (
    <Image
      src={image.url}
      alt={image?.description ?? image?.title?.replace(/\.[^/.]+$/, '')}
      width={image?.dimension?.width}
      height={image?.dimension?.height}
      className="mb-4 h-auto w-full"
      loading="lazy"
    />
  );
};

/**
 * Clean away unwanted connection / edge fields and handle cases where one or
 * more of the images are missing.
 */
const reshapeImageSettings = (imageSettings) => {
  if (imageSettings) {
    const result = {
      desktop: imageSettings?.desktop,
      mobile: imageSettings?.mobile
    };

    // If both are missing, return null
    if (!result.desktop && !result.mobile) {
      return null;
    }

    // Use each other as fallback if one is missing
    if (!result.desktop) {
      result.desktop = result.mobile;
    }
    if (!result.mobile) {
      result.mobile = result.desktop;
    }

    return result;
  }
  return null;
};
